class VersionHelperUtil {
  static EventType = {
    AddProgressBar: "add-progress-bar",
    UpdateProgressBar: "update-progress-bar",
    UpdateComplete: "update-complete",
    UpdateDetails: "update-details",
    UpdateFailed: "update-failed",
  };

  static async getMetaData() {
    return await fetch("../meta.json", { cache: "no-store" }).then((data) => data.json());
  }

  static async getUpdateDetails(versionList) {
    const latestTransformerFile = await import(`./${versionList[versionList.length - 1]}.js`);
    return latestTransformerFile.Transformer.updateDetails;
  }

  static messageDialogChild(dialog, eventType, data) {
    dialog.messageChild(JSON.stringify({ eventType, ...data }));
  }

  static getFormulaGroupsFromRegex(formula) {
    const fwFormulaRegex = /(?<prefix>.*)(?<identifier>FW[D|L]?(_|.)?)(?<functionName>\w+)(?<params>\(.*\))(?<suffix>.*)/i;
    let fwFormula = formula.match(fwFormulaRegex)?.groups;

    if (fwFormula) {
      let params = fwFormula.params;
      let balance = 0;
      let indextoCut = 0;
      for (let i = 0; i < params.length; i++) {
        if (params[i] === ")") balance--;
        if (params[i] === "(") balance++;
        if (balance === 0) {
          indextoCut = i + 1;
          break;
        }
      }
      let suffix = params.slice(indextoCut);
      params = params.slice(0, indextoCut);

      fwFormula = { ...fwFormula, params, suffix: suffix + fwFormula.suffix };
    }

    return fwFormula;
  }

  // static _matchTransformerVersion(versionToMatch, versionList) {
  //   return versionToMatch?.toString().match(/[0-9]\.[0-9]\.[0-9]/g) && versionList.includes(versionToMatch.toString()) ? versionToMatch : null;
  // }

  // static async _loadContent(context, comment, versionList) {
  //   comment.load("content");
  //   await context.sync();

  //   return VersionHelperUtil._matchTransformerVersion(comment.content.split(",")[1]?.trim(), versionList);
  // }

  // static async _loadReplyCount(context, replies) {
  //   let replyCount = replies.getCount();
  //   await context.sync();
  //   return replyCount.value;
  // }

  // static async getFWCommentContent(context, cellAddress, versionList) {
  //   try {
  //     const comments = context.workbook.comments;
  //     const comment = comments.getItemByCell(cellAddress);
  //     const replies = comment.replies;

  //     const replyCount = await VersionHelperUtil._loadReplyCount(context, replies);
  //     if (replyCount < 1) return await VersionHelperUtil._loadContent(context, comment, versionList);

  //     let reply = replies.getItemAt(replyCount - 1);
  //     return await VersionHelperUtil._loadContent(context, reply, versionList);
  //   } catch (e) {
  //     return null;
  //   }
  // }

  // static async deleteFWCommentContent(context, comment, versionList) {
  //   try {
  //     let replies = comment.replies;

  //     const replyCount = await VersionHelperUtil._loadReplyCount(context, replies);
  //     if (!replyCount || replyCount < 1) !!(await VersionHelperUtil._loadContent(context, comment, versionList)) && comment.delete();
  //     else {
  //       let reply = replies.getItemAt(replyCount - 1);
  //       !!(await VersionHelperUtil._loadContent(context, reply, versionList)) && reply.delete();
  //     }
  //   } catch (e) {
  //     console.error({ delete: e, stack: e.stack });
  //   } finally {
  //     await context.sync();
  //   }
  // }

  // static async addFWComment(context, cellAddress, content, versionList) {
  //   const comments = context.workbook.comments;
  //   try {
  //     const comment = comments.getItemByCell(cellAddress);
  //     const replies = comment.replies;
  //     await context.sync();

  //     const content = VersionHelperUtil.getFWCommentContent(context, comment, versionList);
  //     if (!content) replies.add(content);
  //   } catch (e) {
  //     comments.add(cellAddress, content);
  //     await context.sync();
  //   }
  // }

  static indexToLetter(columnIndex) {
    let temp,
      letter = "";
    while (columnIndex > 0) {
      temp = (columnIndex - 1) % 26;
      letter = String.fromCharCode(temp + 65) + letter;
      columnIndex = (columnIndex - temp - 1) / 26;
    }
    return letter;
  }

  static getTransformerFileList(files, currentVersion) {
    let versionList = [];
    files.split(" ").forEach((fileName) => {
      const match = [...fileName.matchAll(/^(?<version>[0-9]*\.[0-9]*\.[0-9]*)\.js$/g)].map((e) => e.groups?.version?.trim());
      if (!Array.isArray(match) || !match.length) return;

      const version = match[0];
      if ((currentVersion || "").replace(/-\w+.*$/g, "").localeCompare(version, undefined, { numeric: true, sensitivity: "base" }) === 1) return;

      versionList.push(version);
    });

    return versionList;
  }

  static async getTransformersObject(versionList) {

    let transformersObject = {};

    for (const transformerVersion of versionList) {
     
      const transformer = (await import(`./${transformerVersion}.js`)).Transformer;
      transformersObject = { ...transformersObject, transformerVersion: transformer };

    }

    return transformersObject;
  }

  static convertStringParamsToList(params) {
    if (!params) return [];
    const paramStart = "(^\\()?";
    const paramMid = `(?<params>('|")[^'"]*('|")\\s*|[^,]*)`;
    const paramEnd = "(?:,\\s*|\\))";
    const paramRegex = new RegExp([paramStart, paramMid, paramEnd].join(""), "gi");

    const paramList = [...params.matchAll(paramRegex)].map((e) => e.groups.params.trim());
    return paramList;
  }

  static async getDocumentProperties(context, key) {
    const customDocProperties = context.workbook.properties.custom;
    const prop = customDocProperties.getItemOrNullObject(key);

    prop.load("value");
    await context.sync();

    return prop.value;
  }

  static async setDocumentProperty(context, key, value) {
    const customDocProperties = context.workbook.properties.custom;
    customDocProperties.add(key, value);

    await context.sync();
  }

  static async lockSheets(sheets, context) {
    for (let sheet of sheets.items) {
      sheet.load("protection/protected");
      await context.sync();

      if (!sheet.protection.protected) sheet.protection.protect();
      await context.sync();
    }
  }

  static getFormattedParams(paramList) {
    let newParam = [];

    let someValue = false;
    for (const param of paramList.reverse()) {
      if (!param && !someValue) continue;
      newParam.push(param);
      someValue = true;
    }
    newParam.reverse();
    newParam = newParam.join(",");

    return newParam;
  }
}

export default VersionHelperUtil;
